export const GALLERY_CATS = [
  { key: "all", en: "All", bn: "সব" },
  { key: "makkah", en: "Makkah", bn: "মক্কা" },
  { key: "madinah", en: "Madinah", bn: "মদিনা" },
  { key: "pilgrims", en: "Pilgrims", bn: "হাজীগণ" },
  { key: "halal", en: "Halal Tours", bn: "হালাল ট্যুর" },
];

export const GALLERY_TX = {
  en: {
    crumb: "Gallery",
    eyebrow: "Moments of Faith",
    title: "Our Gallery",
    sub: "Glimpses from the sacred cities and from the journeys we have been honoured to serve. Hover to preview, click to view, download in one tap.",
    count: (n) => `${n} photos`,
    view: "View",
    download: "Download",
    downloading: "Downloading…",
    close: "Close",
    hint: "Use ← → keys to browse",
  },
  bn: {
    crumb: "গ্যালারি",
    eyebrow: "ঈমানের মুহূর্ত",
    title: "আমাদের গ্যালারি",
    sub: "পবিত্র শহর এবং যেসব সফরে সেবা করার সৌভাগ্য হয়েছে, তার কিছু ঝলক। হোভার করে প্রিভিউ দেখুন, ক্লিক করে বড় করুন, এক ট্যাপে ডাউনলোড করুন।",
    count: (n) => `${n}টি ছবি`,
    view: "দেখুন",
    download: "ডাউনলোড",
    downloading: "ডাউনলোড হচ্ছে…",
    close: "বন্ধ",
    hint: "← → কী দিয়ে ব্রাউজ করুন",
  },
};
